import { Component, OnInit,Input,ElementRef,ViewChild,HostListener } from '@angular/core';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Globals } from '../../globals';
import { FormBuilder,FormGroup,FormControl,Validators } from '@angular/forms';
import {commonService} from "../../service/common.service";
import { ForumsService } from '../../service/forums.service';
import {FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {NgbModal, ModalDismissReasons,NgbModalRef,NgbTimeStruct,NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
declare var MediaStreamRecorder: any;
declare var StereoAudioRecorder:any;
declare var mergeProps:any;
declare var CKEDITOR:any;

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { empty } from 'rxjs/observable/empty';
declare var $: any;
@Component({
  selector: 'app-admin-forum',
  templateUrl: './admin-forum.component.html',
  styleUrls: ['./admin-forum.component.css'],
  providers:[ForumsService,Globals],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})
export class AdminForumComponent implements OnInit {
  ckeConfig: any;
  @ViewChild("ckeditor") ckeditor: any;
  @ViewChild('studentcenterbox', {read: ElementRef}) studentcenterbox: ElementRef;
  @ViewChild('postattachedimg', {read: ElementRef}) postattachedimg: ElementRef;
  @ViewChild('userdetails', {read: ElementRef}) userdetails: ElementRef;
  
  @Input() public options;
  closeResult: string;
  subjects:any;
  forumsFields:any;
  forumsEditFields:any;
  forumsList:any;
  modalReference:NgbModalRef;
  attactmentlist:any=[];
  selectedFile=null;
  attachment:any=[];
  attachmentdetail:any=[];
  fileExtExists=false;
  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.postAttachmentFolder+'&mediaFor=userPost';
  ImageattachmentUrl =this.global.siteUrl+'file/upload?folder=ckeditor&mediaFor=ckeditor';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});
  fileExt: string = "JPG, JPEG, PNG,doc,docx,txt,ppt,pptx";
  commentbox:any;
  ansbox:any;
  anseditbox:any;
  replybox:any;
  commentEditbox:any;
  forumEditbox:any;
  userData:any;
  uploaders:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});;
  imageuploaders:FileUploader=new FileUploader({url:this.ImageattachmentUrl,authToken:sessionStorage.getItem('_to')});;
  currentUploadComment:any={};
  currentCommentMediaIds:any=[];
  msg="";
  isRemaningForum:any;
  state = 'hide';
  isPostLoad:any;
  postId:any;
  msgclass:any="";
  mybookmarkpostId:any;
  currentPost:any;
  searchtopicInput:any=[];
  topicList:any=[];
  selectTopicDetail=[];
  selectTopicIds=[];
  formoptions:any={};
  topicsuggestionList:any=[];
  msgpopup="";
  topicbox:any;
  ngload:any;
  isnewList=false;
  searchFilter:any=[];
  userSearchkey="";
  userList=[];
  selectUser=[];
  question:any={};

 
  audiosContainer:any;
  mediaConstraints = { audio: true }
  recorderType:any;
  thisObj:any; 
  audio:any;
  mediaRecorderObj:any;
  mediaRecorder:any;
  isVoiceActive:any;
  isclickPostQuestion=false;
  othertagBox=false;
  OthertopicInput:any;
  editAnsattachment=null;
  orderNumber:any;
  ckeditorevent:any;
  AttachmentUrl:any;
  AttachedImagePopup:any;
  postTitle:any;;
  userProfileData:any;
  progress:any;
  constructor(public el: ElementRef, private modalService: NgbModal,private forumsService:ForumsService,private commonService:commonService,private global: Globals,private router: Router,private route: ActivatedRoute) { 
    
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);

    this.uploaders.onErrorItem = (item, response, status, headers) => this.onErrorItemComment(item, response, status, headers);
    this.uploaders.onSuccessItem = (item, response, status, headers) => this.onSuccessItemComment(item, response, status, headers);

    this.imageuploaders.onErrorItem = (item, response, status, headers) => this.onErrorItemImage(item, response, status, headers);
    this.imageuploaders.onSuccessItem = (item, response, status, headers) => this.onSuccessItemImage(item, response, status, headers);

    this.commentbox={};
    this.ansbox={}; 
    this.anseditbox={}
    this.replybox={};
    this.commentEditbox={};
    this.forumEditbox={};
    this.isRemaningForum=true;
    this.mybookmarkpostId=[];
    //this.commentEditbox[4]="Tetetetetete";
   
   
    this.commonService.profile.subscribe((data:any)=>{
     // console.log('after Load call sub');
      if(data){
      this.userData=data; 
      }else{
        this.userData={};
      } 

    });
   // console.log('after Load call');
    //console.log(this.userData);

   if(this.options){
    this.formoptions=this.options;
    }


    this.isPostLoad=false; 
    this.postId=0;
    this.currentPost={};
    this.route.params.subscribe((params: Params) => {
      if(params['id']){        
      this.postId = parseInt(params['id']);
      if(isNaN(this.postId)){
        this.postId=0;
      }      
      let filter={};
      filter={id:this.postId};   
        if(this.ngload==true && this.postId >0){
          this.getForumDetail(filter);
        } 
     

     
      }
      
    });
    
    this.AttachmentUrl= this.global.postAttachmentUrl;
    this.topicbox=[];
    this.ngload=false;
    
  }



    @HostListener('window:scroll', ['$event'])
    checkScroll() {
       var scrollPosition = $(window).scrollTop() + $(window).height();
       //var pageheight =  $(document).height()-$('#footer-section').outerHeight();
       var pageheight =  $(document).height()-100;
       if(scrollPosition >= pageheight && this.isRemaningForum==true && this.postId==0 && this.isPostLoad!=true) {
         this.isPostLoad=true;        
         this.loadmoreForum();
       }
 
  }
      
      open(content) {
        this.msgpopup="";
        this.modalReference =  this.modalService.open(content,{ size: 'lg' }); 
       /* this.modalReference= this.modalService.open(content,{size:"lg"}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });*/

             
      }
      needLogin(){
        this.commonService.setLoginBox(true);        
      }

    
      

      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return  `with: ${reason}`;
        }
      }
    
      /*============================== Forums Code=========================*/
      getForums(obj)
      {        
        obj['orderby']="id";
      
        if(obj['limit'] > 0){
          if(obj.offset!=null){
            obj['offset']=obj.offset;
          }else{
            obj['offset']= this.forumsList.length;
          }          
        }   
        
        
        if(this.formoptions.topicId > 0){
          obj['topicId']=this.formoptions.topicId;  
        }

        if(this.searchFilter['question']){
          obj['question']=this.searchFilter['question'];
        }

        if(this.selectTopicIds.length > 0){
          obj['topics']=this.selectTopicIds;
        }
        if(this.selectUser.length > 0){
            obj['userIds']=this.selectUser;

        }

        //  add for  profile question
      if(this.formoptions.type !=""){
        obj['type']=this.formoptions.type ;  
      }

      if(this.formoptions.puserId !="" && this.formoptions.puserId >0){
        obj['puserId']=this.formoptions.puserId ;  
      }

        this.isPostLoad=true;
     
        
        this.forumsService.getforums(obj).subscribe((data:any)=>{
          this.isPostLoad=false;
        // console.log("getForums");
        // console.log(data);
          if(data.error==0){        
            if(data.result.length > 0){
              for(let i in data.result){
               // 
               if(data.result[i].postAnswers.length > 0){
                 for(let j=0; j < data.result[i].postAnswers.length; j++){
                   if(data.result[i].postAnswers[j].isDelete==1){
                      data.result[i].postAnswers.splice(j,1);
                      continue;
                    }
                   this.customContent(data.result[i].postAnswers[j]);
                   this.forumEditbox[data.result[i].postAnswers[j].id]=data.result[i].postAnswers[j].answer;
                   this.anseditbox[data.result[i].postAnswers[j].id]=data.result[i].postAnswers[j].answer;
                   //data.result[i].postAnswers[j].shortans= data.result[i].postAnswers[j].answer;
                  //data.result[i].postAnswers[j].shortans= data.result[i].postAnswers[j].answer;

                    
                 }
               }

              }
            }else{
              this.isRemaningForum=false;
            }
           
          

            if(obj['isnewList']==true){
              Array.prototype.push.apply(this.forumsList,data.result);             
             // this.isnewList=false;
            }else{
              this.forumsList=data.result;
            } 
          }else{    
    
          }
    
        },(error : HttpErrorResponse)=>{    
          this.isPostLoad=false;  
          this.msg="internal server error!";
        });    
      }

      getForumDetail(obj)
      {  

        console.log('getForumDetail');     
        obj['orderby']="id";
    
        this.isPostLoad=true;
        this.forumsService.getforumDetail(obj).subscribe((data:any)=>{
          this.isPostLoad=false;
     
          if(data.error==0){
            console.log(data.result);        
            if(data.result.length > 0){
              for(let i in data.result){
                this.forumEditbox[data.result[i].id]=data.result[i].postContent;
                if(data.result[i].postAnswers.length > 0){
                  for(let j=0; j < data.result[i].postAnswers.length; j++){
                    
                    this.anseditbox[data.result[i].postAnswers[j].id]=data.result[i].postAnswers[j].answer;
                   //data.result[i].postAnswers[j].shortans= data.result[i].postAnswers[j].answer;
                   //data.result[i].postAnswers[j].shortans= data.result[i].postAnswers[j].answer;
 
 
                  }
                }

                //this.getForumDetail[]
              }
            }else{

              this.isRemaningForum=false;
            }

           
            // /console.log(data.result);
            //this.forumsList.push(data.result);
            this.forumsList=data.result;
            this.isnewList=true;
           // Array.prototype.push.apply(this.forumsList,data.result); 
         
          }else{    
    
          }
    
        },(error : HttpErrorResponse)=>{    
          this.isPostLoad=false;  
          this.msg="internal server error!";
        });    
      }


      saveForums(forumsForm:NgForm,postType){
        
        this.isclickPostQuestion=true;
        this.msgpopup="";
        let localmodalReference=this.modalReference;
      
       
        
        if(this.userData.isBlocked == 1){
          this.msgclass="danger";
          this.msgpopup="You have no permission to post question, Please contact to MadeEasy";
          this.isclickPostQuestion=false;
          return false;
        }
        
        if(forumsForm.value.postTitle==undefined){
          this.isclickPostQuestion=false;
          this.msgclass="danger";
          this.msgpopup="Please enter question!";
          return false;
        }

        
        if(forumsForm.value.searchtopicInput==null){
            forumsForm.value.searchtopicInput=[];
            this.searchtopicInput=[];
        }
        if(forumsForm.value.OthertopicInput==null){
          forumsForm.value.OthertopicInput=undefined;
        }
        
        if((forumsForm.value.searchtopicInput.length==0 && ("OthertopicInput" in forumsForm.value===false || typeof forumsForm.value.OthertopicInput=='undefined'))){
          this.isclickPostQuestion=false;
          this.msgclass="danger";
          this.msgpopup="Please enter tag!";
          return false;
        }
       
        if(forumsForm.valid==true){
          
          let forumsObj=forumsForm.value; 
          forumsObj.postTitle[forumsObj.postTitle.length -1];
          forumsObj.userid=this.userData.id;
          forumsObj.mediaids=this.attachment;
          forumsObj.postType=postType;
          
          forumsObj.topics=[];
          for(let i in this.searchtopicInput){
            forumsObj.topics.push(this.searchtopicInput[i].value);
          }
         
          /*if(forumsObj.postTitle[forumsObj.postTitle.length -1]!='?'){
            forumsObj.postTitle =forumsObj.postTitle+'?';
          }*/

          //return false;
         

          this.forumsService.addforums(forumsObj).subscribe((data:any)=>{
            this.isclickPostQuestion=false;
            if(data.error==0){
                var setData={};
                setData=data.result;
                setData['userId']=this.userData.id;
                setData['user']={};
                setData['user'].firstName=this.userData.firstName;
                setData['user'].lastName=this.userData.lastName;
                setData['user'].photo=this.userData.photo;
                setData['user'].id=this.userData.id;
                setData['postTopicAssigns']=[];
                setData['postAnswers']=[];

                if(postType=="Post"){
                       var tmpAns = {};
                       tmpAns['answer']=forumsObj['postTitle'];
                       tmpAns['user']= setData['user'];
                       tmpAns['isfullcontent'] =true;
                       tmpAns['isDelete'] = 0;  
                       setData['postAnswers'].push(tmpAns);
                }

                setData['postOtherTopicAssigns']=[];
                setData['ansCount']=0;
                  if(this.searchtopicInput.length > 0){
                    for(let i in this.searchtopicInput){
                      var tmptopic={};
                      tmptopic['id']=0;
                      tmptopic['topicId']=this.searchtopicInput[i].value;
                      tmptopic['postId']=data.result.id;
                      tmptopic['postTopic']={id:this.searchtopicInput[i].value,title:this.searchtopicInput[i].display};
                      setData['postTopicAssigns'].push(tmptopic);

                    }
                  }


                  if("OthertopicInput" in forumsForm.value===true &&  typeof forumsForm.value.OthertopicInput!='undefined'){
                    for(let i in forumsForm.value.OthertopicInput){
                      var tmptopic={};
                      tmptopic['id']=0;
                      tmptopic['postId']=data.result.id;
                      tmptopic['topic']=forumsForm.value.OthertopicInput[i].display;
                      setData['postOtherTopicAssigns'].push(tmptopic);

                    }
                  }

               setData['postAttachments']  =this.attachmentdetail;

               this.forumsList.unshift(setData);
               this.attachmentdetail=[];
               this.attachment=[];
               this.uploader.queue=[];
               forumsForm.resetForm();              
               localmodalReference.close();
              


            }else if(data.error==2){
              this.msgclass="danger";
              this.msgpopup=data.message;;

            }else{

              this.msgclass="danger";
              this.msg="there is some technical problem";
            }

          },(error : HttpErrorResponse)=>{      
            this.msg="internal server error!";
          })
         // this.forumsService.addforums(forumsObj);
        }else{
       
          this.isclickPostQuestion=false;
          this.msgclass="danger";
          this.msgpopup="Please fill all required fields!";

        }
      }
  

      editForums(forumsForm:NgForm,obj,currentPost){
    
        //  console.log(currentPost);
          this.isclickPostQuestion=true;
          let localmodalReference=this.modalReference;
  
          if(forumsForm.value.postTitle==""){
            this.isclickPostQuestion=false;
            this.msgclass="danger";
            this.msgpopup="Please enter question!";
            return false;
          }
         
  
          if((forumsForm.value.searchtopicInput.length==0 && ("OthertopicInput" in forumsForm.value===false || forumsForm.value.OthertopicInput.length==0))){
            this.isclickPostQuestion=false;
            this.msgclass="danger";
            this.msgpopup="Please enter tag!";
            return false;
          }
  
          if(forumsForm.valid==true){
            forumsForm.value['mediaids']=this.attachment;
            forumsForm.value.id=obj.id;
            forumsForm.value.postType=currentPost.postType;
            this.forumsService.editforums(forumsForm.value).subscribe((data:any)=>{  
            
              if(currentPost.postType=="Post"){
                currentPost.postAnswers[0].answer=forumsForm.value['postTitle'];
              }
               this.isclickPostQuestion=false;
                this.currentPost.postTitle= this.forumsEditFields.postTitle;
               // this.currentPost.postContent=  this.forumsEditFields.postContent;
              //  this.currentPost.subjectid= this.forumsEditFields.subjectid;            
                this.currentPost.anonymously= this.forumsEditFields.anonymously;
                if(data.error==0){
                  currentPost.postTopicAssigns=[];
                  currentPost.postOtherTopicAssigns=[];
                  if(forumsForm.value.searchtopicInput.length > 0){
                    
                    for(let i in forumsForm.value.searchtopicInput){
                      var tmptopic={};
                      tmptopic['id']=0;
                      tmptopic['topicId']=forumsForm.value.searchtopicInput[i].value;
                      tmptopic['postId']=obj.id;
                      tmptopic['postTopic']={id:forumsForm.value.searchtopicInput[i].value,title:forumsForm.value.searchtopicInput[i].display};
                      currentPost.postTopicAssigns.push(tmptopic);
  
                    }
                  }
  
                  if("OthertopicInput" in forumsForm.value===true &&  forumsForm.value.OthertopicInput.length>0){
                   
                    for(let i in forumsForm.value.OthertopicInput){
                      var tmptopic={};
                      tmptopic['id']=0;
                      tmptopic['postId']=obj.id;
                      tmptopic['topic']=forumsForm.value.OthertopicInput[i].display;
                      currentPost.postOtherTopicAssigns.push(tmptopic);
  
                    }
                  }
                 // if(this.attachmentdetail.length>0){
                  for(let obj of this.attachmentdetail){
                     currentPost.postAttachments.push(obj);
                  //}
                }
                this.attachment=[];
                 this.attachmentdetail=[];
                  this.searchtopicInput=[];
                }
                
               
                this.uploader.queue=[];
  
                forumsForm.resetForm(); 
                localmodalReference.close();
            },(error : HttpErrorResponse)=>{                  
              this.msg="internal server error!";
            })    
  
          }else{
            this.msg="There is some technical problem";
          }
  
        }
  


      deleteForum(postObj,index){
        var r=confirm("Do you want to delete ?");
        if(r==true){
          let obj={};
          obj['id']=postObj.id;
      this.forumsService.deleteForum(obj).subscribe((data:any)=>{
        this.forumsList.splice(index,1);

      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";

      })
         

        }
      }
      editForumBox(postObj,editcontent){
  
        this.currentPost=postObj;
       
        this.forumsEditFields.id=postObj.id;
        this.forumsEditFields.postTitle=postObj.postTitle;
        this.forumsEditFields.postType= postObj.postType;
        //this.forumsEditFields.postContent=postObj.postContent;
        //this.forumsEditFields.subjectid=postObj.subjectid;               
        this.forumsEditFields.anonymously=(postObj.anonymously==0)?false:true;  
       
        if(postObj){
          this.searchtopicInput=[];
          this.OthertopicInput=[];
          
         // this.selectTopicDetail=[];
          for (let i in postObj.postTopicAssigns){
            let  tmp={};
            tmp['display']=postObj.postTopicAssigns[i].postTopic.title;
            tmp['value']=postObj.postTopicAssigns[i].postTopic.id;
            this.searchtopicInput.push(tmp);
          }


          if(postObj.postOtherTopicAssigns.length>0){
            this.othertagBox=true;
          }else{
            this.othertagBox=false;
          }
          for (let i in postObj.postOtherTopicAssigns){
            let  tmp={};
            
            tmp['display']=postObj.postOtherTopicAssigns[i].topic;
            tmp['value']=postObj.postOtherTopicAssigns[i].id;
            this.OthertopicInput.push(tmp);

          }
          //console.log(this.OthertopicInput);


        }
       // console.log(this.selectTopicDetail);
       // this.forumsEditFields.mediadata=postObj.postAttachments;       
       // console.log(this.forumsEditFields);
        this.open(editcontent);
        //postObj.editMode=true; 
        postObj.showOption=false;         

      }

      trending(forum){
        let obj={};
        obj['postId']=forum.id;
          this.forumsService.trandingPost(obj).subscribe((data:any)=>{
            if(data.error==0){
              forum.isTranding=data.result;
            }            
          },(error:HttpErrorResponse)=>{
            this.msg="internal server error!";
          })
      }

      loadAnswer(forum){
        let obj={};
        obj['id']=forum.id;
        obj['limit']=5;
        obj['offset']=forum.postAnswers.length;
        obj['order']=[['isDelete','asc'],['id','DESC']];        
        this.forumsService.getQuestionAnswer(obj).subscribe((data:any)=>{
            if(data.error==0){
                
                if(data.result.length > 0){
                  forum.postAnswers=[];
                  for(let i=0; i < data.result.length; i++){
                    this.customContent(data.result[i]);
                    this.forumEditbox[data.result[i].id]=data.result[i].answer;
                    this.anseditbox[data.result[i].id]=data.result[i].answer;

                  }
                }


                Array.prototype.push.apply(forum.postAnswers,data.result);                 

            }
        },(error:HttpErrorResponse)=>{

           this.msg="internal server error!";
        })

      }
      removeMedia(mediaObject, index){

        if(!this.forumsEditFields.removeMedia){
          this.forumsEditFields.removeMedia=[];
        }

        this.forumsEditFields.removeMedia.push(mediaObject[index].id);        
        mediaObject.splice(index, 1);     

      }
      loadmoreForum(){
        //console.log('loadmoreForum');
        this.getForums({limit:10,isnewList:true});
      }

      enableEditor(Obj){
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();
          return false;
        } 
        Obj.isEditor=true;

      }

      setPageCount(){
        let obj={}
        obj['postId']=this.postId;
        obj['userId']=this.userData.id;    
        this.forumsService.setPageCount(obj).subscribe((data:any)=>{          
       
            if(data.error==0){
                  this.forumsList[0].postViewCount +=1;
            }
        },(error:HttpErrorResponse)=>{
          this.msg="internal server error!";
        })
    
      }
/*=============================== Show Hide Boxes ====================================*/
      showAttachmentBox(postObj){
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();
          return false;
        } 
        postObj.showCommentBox=false;
        if(postObj.showAttachment){
          postObj.showAttachment=false;
        }else{
          postObj.showAttachment=true;
        }
      }
     

      showAnsBox(postObj){
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();
        //  alert('Please Login');
          return;

        }

        if(postObj.showAnsBox){
          postObj.showAnsBox=false;
        }else{
          postObj.showAnsBox=true;
        }

      }

      showCommentBox(postObj){
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();
          return false;
        } 
        postObj.showAttachment=false;
        if(postObj.showCommentBox){
          postObj.showCommentBox=false;
        }else{
          postObj.showCommentBox=true;
          
          if(postObj.commentCount > postObj.commentCount && postObj.commentCount < 5){
            postObj.isCommentLoad=true;
            var obj={};
            obj['userId']=this.userData.id;
            obj['ansId']=postObj.id;
            obj['limit']=5;
            obj['offset']=postObj.commentList.length;
          
            this.forumsService.getComments(obj).subscribe((data:any)=>{
             
              if(data.error==0){
                if(data.result){
                  for(let i in data.result){  
                    this.commentEditbox[data.result[i].id]=data.result[i].comment;
                  }
                }
                
                Array.prototype.push.apply(postObj.commentList,data.result); 
                //postObj.postComments.concat(data.result);
               // console.log(postObj.postComments);
              }
              postObj.isCommentLoad=false;
  
  
  
            },(error : HttpErrorResponse)=>{ 
              postObj.isCommentLoad=false;     
              this.msg="internal server error!";
            })
  
  
          }
        }
      }

      replyTextboxShow(commentdata){
        
        if(commentdata.isShow){
          commentdata.isShow=false;

        }else{

          commentdata.isShow=true;
          
          if(!commentdata.commentList){
             commentdata.commentList=[];
          }
          if(commentdata.commentCount > commentdata.commentList.length && commentdata.commentList.length < 5){
           
            commentdata.isCommentLoad=true;
          var obj={};
           obj['userId']=this.userData.id;
           obj['ansId']=commentdata.postId;
           obj['pcomment']=commentdata.id;
           obj['limit']=5;
           obj['offset']=commentdata.commentList.length;
           obj['ordertype']='DESC';
           obj['orderby']='id';
          
            this.forumsService.getComments(obj).subscribe((data:any)=>{
             
              if(data.error==0){
                if(data.result){
                  for(let i in data.result){
  
                    this.commentEditbox[data.result[i].id]=data.result[i].comment;
                  }
                }
                Array.prototype.push.apply(commentdata.commentList,data.result); 
                //postObj.postComments.concat(data.result);
                console.log(commentdata.commentList);
              }
              commentdata.isCommentLoad=false;
  
  
  
            },(error : HttpErrorResponse)=>{ 
              commentdata.isCommentLoad=false;     
              this.msg="internal server error!";
            })
  
  
          }




        }

      }
      toggleoption(postObj){     
        
       
        if(postObj.showOption){
          postObj.showOption=false;
        }else{
          postObj.showOption=true;
        }
      }

      getpostDetailUrl(id){ 
        let str = CryptoJS.AES.encrypt(id.toString(), 'angualr@2018');  

        var e64 = CryptoJS.enc.Base64.parse(str.toString());
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return eHex;
       //return 'forums/detail/'+eHex;
      }
      /*===================================== Comment ==============================*/
      savereply(commentobj,commentValue){
        
        let objthis=this;
        if(commentValue){
              let commentInsertObj={}
              commentInsertObj['comment']=commentValue;
              commentInsertObj['ansId']=commentobj.postId;
              commentInsertObj['userId']=this.userData.id;
              commentInsertObj['pcomment']=commentobj.id;
              commentInsertObj['mediaids']=[];
              if(this.currentCommentMediaIds){
                for(let i in this.currentCommentMediaIds){
                  commentInsertObj['mediaids'].push(this.currentCommentMediaIds[i].id);
                }
              }   

              this.forumsService.saveComment(commentInsertObj).subscribe((data:any)=>{
                
                if(data.error==0){
                  let commentData=data.result;
                 
                  commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
                  commentData.likeCount=0;
                  if(!commentobj.commentList){
                    commentobj.commentList=[];
                  }
                  commentData.commentAttachments=this.currentCommentMediaIds;
                 
                 // if(commentobj.commentList.length<5){
                    commentobj.commentList.unshift(commentData);
                 // }
                  commentobj.commentCount +=1;
                  objthis.replybox[commentobj.id]="";
                  commentobj.commentMedia=[];
                }
                this.currentCommentMediaIds=[];


              },(error : HttpErrorResponse)=>{  
                
                  this.msg="internal server error!";
              })

        }       

      }

      saveComment(postObj,commentValue){

        let objthis=this;
        if(commentValue){
              let commentObj={}
              commentObj['comment']=commentValue;
              commentObj['postId']=postObj.id;
              commentObj['userId']=this.userData.id;
              commentObj['mediaids']=[];
              if(this.currentCommentMediaIds){
                for(let i in this.currentCommentMediaIds){
                  commentObj['mediaids'].push(this.currentCommentMediaIds[i].id);

                }
              }     
              
             
              this.forumsService.saveComment(commentObj).subscribe((data:any)=>{
                
                if(data.error==0){
                  let commentData=data.result;                 
                  commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
                  commentData.likeCount=0;
                  
                  commentData.commentAttachments=[];

                  if(this.currentCommentMediaIds){
                    for(let k in this.currentCommentMediaIds){
                      let tmp=this.currentCommentMediaIds[k];
                      tmp.id=null;
                      commentData.commentAttachments.push(tmp);
                    }
                  }
                 // commentData.commentAttachments=this.currentCommentMediaIds;
                  if(!postObj.commentList){
                    postObj.commentList=[];
                  }
                  //if(postObj.postComments.length<5){
                    postObj.commentList.unshift(commentData);
                    console.log(postObj.commentList);
                  //}
                
                  postObj.commentCount +=1;
               

                  postObj.commentMedia=[];
                  this.commentbox[postObj.id]="";

                  postObj.showAnscomment=false;
                  this.showAnscomment(postObj);
                }
                this.currentCommentMediaIds=[];


              },(error : HttpErrorResponse)=>{  
                  
                  this.msg="internal server error!";
              })

        }        
      
      }

      loadComment(postObj,forcall,divobject){
        if(!postObj.commentList){
          postObj.commentList=[];

        }
        if(postObj.commentCount > postObj.commentList.length ){
          postObj.isCommentLoad=true;

          console.log(forcall);
        var obj={};
         if(this.userData)
         obj['userId']=this.userData.id;
        
         obj['limit']=5;
         obj['offset']=postObj.commentList.length;
         if(forcall=='Comment'){
          obj['postId']=postObj.id;
         }else if(forcall=='reply'){
          obj['postId']=postObj.postId;
          obj['pcomment']=postObj.id;
         }

         obj['ordertype']='DESC';
         obj['orderby']='id';

         console.log(obj);
         console.log(postObj);

        
          this.forumsService.getComments(obj).subscribe((data:any)=>{
           
            if(data.error==0){
              if(data.result){
                for(let i in data.result){

                  this.commentEditbox[data.result[i].id]=data.result[i].comment;
                }
              }
              //console.log( this.commentEditbox);
              Array.prototype.push.apply(postObj.commentList,data.result); 
              //console.log(postObj.commentList);
             // var objDiv = document.getElementById(divobject);
           
             
           // objDiv.scrollTop =  objDiv.scrollHeight - objDiv.clientHeight;
              /*let divobj=$("#"+divobject)[0];
              console.log("height "+$("#"+divobject).height());
              $("#"+divobject).scrollTop($("#"+divobject).height());
              console.log(divobj);*/
             // divobject.scrollIntoView();
              //postObj.postComments.concat(data.result);
           
            }
            postObj.isCommentLoad=false;



          },(error : HttpErrorResponse)=>{ 
            postObj.isCommentLoad=false;     
            this.msg="internal server error!";
          })


        }
      }

      showAnscomment(postAns){
       
        if(postAns.showAnscomment==true){
    
          postAns.showAnscomment=false;          
          return false;
        }
       // console.log('asdasdad');
       if(!postAns.commentList || postAns.commentList.length==0){        
        //console.log(postAns.showAnscomment);
        this.loadComment(postAns,'Comment','');
       
       }
       postAns.showAnscomment=true;  
      

      }

      deleteComment(commentObj,parentObj,index){
        var obj={};
        obj['id']=commentObj.id;
        this.forumsService.deleteComment(obj).subscribe((data:any)=>{
          if(data.error==0){
            try{
              parentObj.commentList.splice(index, 1);
            //  if(parentObj.postComments){
              // parentObj.postComments.splice(index,1);       // For Comment
             // }else{
                parentObj.commentCount -=1; // for reply && comment
 
         //     }   
          
            }catch(e){
              console.log(e);
            }            
          }
        },(error:HttpErrorResponse)=>{
          this.msg="internal server error!";
        })

      }

      openEditComment(commentObj){    
        console.log(commentObj);
        console.log(this.commentEditbox);   
        commentObj.editMode=true; 
        commentObj.showOption=false;          
      }

      cancelEditComment(commentObj){
        commentObj.editMode=false;
      }
      EditComment(commentObj){
        //commentObj.comment=;
        
      let obj = {};
      obj['id']=commentObj.id;
      obj['comment']=this.commentEditbox[commentObj.id];
        this.forumsService.editComment(obj).subscribe((data:any)=>{
          commentObj.editMode=false;
          commentObj.comment=this.commentEditbox[commentObj.id];
        })

      }
      onCommenteditMode($event,commentObj){       
      
        this.commentEditbox[4]=commentObj.comment;  

      }

      removeCommentAttachment(obj,index){
        if(confirm("Do you want to delete ?")){ 
          this.forumsService.removeCommentAttachment(obj[index]).subscribe((data:any)=>{
            if(data.error==0){
              try{
                obj.splice(index, 1);
              }catch(e){
                console.log(e);
              }            
            }
          },(error:HttpErrorResponse)=>{
            this.msg="internal server error!";
          })
        }    
      }


      /*============================== Ans ===================*/
      saveAns(postObj,ansValue){
       
       
        let ansObj={}
        ansObj['answer']=ansValue;
        ansObj['postId']=postObj.id;
        ansObj['userId']=this.userData.id;
        ansObj['mediaids']=[];


        
        if(this.currentCommentMediaIds){
          for(let i in this.currentCommentMediaIds){
            ansObj['mediaids'].push(this.currentCommentMediaIds[i].id);

          }
        }   
        let objthis=this;
        this.forumsService.saveAnswer(ansObj).subscribe((data:any)=>{
                
          if(data.error==0){
            let ansData=data.result;
           
            ansData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
           // console.log(ansData);
            //console.log(postObj);
            if(!postObj.postAnswers){
              postObj.postAnswers=[];
            }
            if(!postObj.ansCount){
              postObj.ansCount=0;
            }
            ansData.ansAttachments=this.currentCommentMediaIds;

            postObj.showAnsBox=false;

            ansData
            postObj.postAnswers.push(ansData);
            postObj.ansCount +=1;
            //Array.prototype.push.apply(postObj.postAnswers,ansData);
           // console.log('update post data');    
            //console.log(this.forumsList); 
            //console.log(postObj);
            //
            this.ansbox[postObj.id]="";
            this.customContent(postObj.postAnswers[postObj.postAnswers.length-1]);
           // ansValue="";
          //  postObj.commentMedia=[];
          }
          this.currentCommentMediaIds=[];


        },(error : HttpErrorResponse)=>{  
          console.log(error);    
            this.msg="internal server error!";
        })

       


      }

      editmodeAnswer(ans){
        console.log(this.anseditbox);
        console.log(ans.id);
        ans.editmode=true;
        
      }

      deleteAnswer(ans,question,index){

        let r =confirm('do you want to delete?');
        if(r==true){
          this.forumsService.deleteAns({id:ans.id,userId:ans.userid}).subscribe((data:any)=>{
            if(question.ansCount > 0){
              question.ansCount -=1;
              question.postAnswers.splice(index,1);  
             // question.postAnswers.
            }
          },(error:HttpErrorResponse)=>{

            this.msg="internal server error!";
          })

        }
      }

      updateAns(ans){
        let ansvalue=this.anseditbox[ans.id];
        let obj={};
        obj['id']=ans.id;
        obj['answer']=ansvalue;

        obj['attachment']=ans.tmpAttachment;

          this.forumsService.updateAnswer(obj).subscribe((data:any)=>{
            if(data.error==0){
              ans.answer=ansvalue;
              this.customContent(ans);
              ans.editmode=false;
              
              if(!ans.ansAttachments)
               ans.ansAttachments=[];

               if(ans.tmpAttachment){
                 for (var key in ans.tmpAttachment){
                  ans.ansAttachments.push(ans.tmpAttachment[key]);
                 }
               }
               ans.tmpAttachment=[];            
            }         

          },(error:HttpErrorResponse)=>{
            this.msg="internal server error!";
          })

      }

      /*=============================== Like =================*/
      postLike(postObj,react){ 
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();
          return false;
        }      
        var obj={};
        obj['userId']=this.userData.id;
        obj['ansId']=postObj.id;
        obj['react']=react;            
            this.forumsService.savePostLike(obj).subscribe((data:any)=>{
              if(!postObj.ansLikeCount){
                postObj.ansLikeCount=0;
              }
              if(!postObj.ansunLikeCount){
                postObj.ansunLikeCount=0;
              }
              if(react==0){                
                if(postObj.mylikeAction=='Like'){
                  postObj.mylike=0;
                  postObj.ansLikeCount -=1;
                  postObj.ansunLikeCount +=1;
                }else if(!postObj.mylikeAction){
                   postObj.ansunLikeCount +=1;
                }
                postObj.mylikeAction='Unlike';

              }else{
                if(postObj.mylikeAction=='Unlike'){
                  postObj.mylike=1;
                  postObj.ansLikeCount +=1;
                  postObj.ansunLikeCount -=1;
                }else if(!postObj.mylikeAction){
                   postObj.ansLikeCount +=1;
                }
                postObj.mylikeAction='Like';

              }
                           
            },(error : HttpErrorResponse)=>{              
                this.msg="internal server error!";
            })   
        

      }

      commentLike(commentData){
        if(Object.keys(this.userData).length == 0){ 
          this.needLogin();  
          return;
        }
        var obj={};
        obj['userId']=this.userData.id;
        obj['commentId']=commentData.id;
        obj['react']=1;  

          if(commentData.mylike){            
            this.forumsService.deleteCommentLike(obj).subscribe((data:any)=>{
              if(data.error==0){
              commentData.mylike=0;
              commentData.likeCount -=1;
              }
            },(error : HttpErrorResponse)=>{              
                this.msg="internal server error!";
            })              

          }else{            

            this.forumsService.saveCommentLike(obj).subscribe((data:any)=>{
              if(data.error==0){
              commentData.mylike=1;
              commentData.likeCount +=1;
              }
            },(error : HttpErrorResponse)=>{              
                this.msg="internal server error!";
            })            
          }

      }


      
/*=============================== Bookmark ===================================*/

bookmark(postObj,type){
var obj={};
obj['postId']=postObj.id;
obj['userId']=this.userData.id;
obj['type']=type;
this.forumsService.bookmark(obj).subscribe((data:any)=>{
  if(data.error==0){
    if(type=='bookmark'){
      postObj.mybookmark=1;
    }else{
      postObj.mybookmark=0;
    }
    postObj.showOption=false;

  }

},(error:HttpErrorResponse)=>{
  this.msg="internal server error!";
})

}

isbookmark(postObj){  
  let a = this.mybookmarkpostId.indexOf(postObj.id);
  if(a !== -1){
    return true;
  }else{
    return false;
  }
}

getMyBookmark(){
  let obj={};
  obj['userId']=this.userData.id;
  this.forumsService.getmybookmark(obj).subscribe((data:any)=>{
    if(data.error==0){
      
     
      if(data.result){
        for(let i in data.result){
          this.mybookmarkpostId.push(data.result[i].postId);

        }

      }
     
    }
    
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";

  })
}

/**************Follower************/

questionFollower(postObj){
  if(Object.keys(this.userData).length == 0){ 
    this.needLogin();  
    return;
  }
let obj={userId:this.userData.id, postId:postObj.id};

this.forumsService.followQuestion(obj).subscribe((data:any)=>{
  if(data.error==0){

    if(data.result=='add'){
      postObj.isFollow=1;
    }else if(data.result=='sub'){
      postObj.isFollow=0;
    }
  
  }

},(error:HttpErrorResponse)=>{

  this.msg="internal server error!";
})
 
}

ShortOrder(feed){
  this.orderNumber='';
 if(feed.shortOrderBox){
  feed.shortOrderBox=false;
}else{
  feed.shortOrderBox=true;
}

}

ordernumbersave(feed,order){
     
  let InsertObj={}
  InsertObj['postId']=feed.id;
  //InsertObj['userId']=this.user.id;
  InsertObj['shortOrder']   = (order==0 || order=="")?'X':order;
  this.forumsService.saveshortOrder(InsertObj).subscribe((data:any)=>{
    if(data.error==0){
        feed.shortOrder=order;
        feed.shortOrderBox=false;
      }else{
        this.msg="internal server error!";
      }},(error : HttpErrorResponse)=>{  
    
      this.msg="internal server error!";
  })


  }

userFollower(user){
  if(Object.keys(this.userData).length == 0){ 
    this.needLogin();
    return false;
  } 
  let obj={}
  obj['f_userid']=(this.userData.id)?this.userData.id:0;
  obj['t_userid']=user.id;
  this.forumsService.userFollower(obj).subscribe((data:any)=>{
        if(data.error==0){
      
          if(data.result=='add'){
            if(parseInt(user.follower) == null){
              user.follower=0;
            }
            if(parseInt(user.ismyfollow) == null){
              user.ismyfollow=1;
            }
            
            user.follower = parseInt(user.follower) + 1;
            user.ismyfollow=1;
            console.log(user);

          }else if(data.result=='sub'){
            if(parseInt(user.follower) == null){
              user.follower=0;
            }
            if(parseInt(user.ismyfollow) == null){
              user.ismyfollow=0;
            }
            
            user.follower = parseInt(user.follower) - 1;
            user.ismyfollow=0;
            console.log(user);
          }
          
        }
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";
  })

}
/******************************* */

/******* Topic *************/

getAllTopic(){
  let obj={};
  this.forumsService.getPostTopic(obj).subscribe((data:any)=>{
   // console.log(data);
    if(data.error==0){
   
      for( let i in data.result){
        let tmpobj={};
        tmpobj['display']=data.result[i].title;
        tmpobj['value']=data.result[i].id;
        this.topicbox.push(tmpobj);   
      }

    }
    console.log(this.topicbox);
    //this.topicbox=data.result;
},(error:HttpErrorResponse)=>{

  this.msg="internal server error!";
})

}
searchTopic($event){

  let obj={};
  obj['searchtitle']=this.searchtopicInput;

    

  this.forumsService.getPostTopic(obj).subscribe((data:any)=>{
      console.log(data);
      this.topicList=data.result;
  },(error:HttpErrorResponse)=>{

    this.msg="internal server error!";
  })
}


selectTopic(topic, event){
  if(event.target.checked) {
    this.selectTopicIds.push(topic.value);
  } else {

    var index =  this.selectTopicIds.indexOf(topic.value);
    this.selectTopicIds.splice(index,1);   
  } 
  //console.log( this.selectTopicIds);
}

removeTag(index){
  //delete (this.selectTopicDetail[index]);
  this.selectTopicDetail.splice(index,1);
  this.selectTopicIds.splice(index,1);  

}



/*===========================================================================*/
     


      getImagePath(path,anonymously){
        if(!path || anonymously==1){
          path='avatar.png';
        }
      let res=this.global.profileUrl+path;
      return res;

      }

      datediff(date){
       let date_future:any;
       let date_now:any;

        date_future = new Date();
        date_now = new Date(date);
        let seconds = Math.floor((date_future - (date_now))/1000);
        let minutes = Math.floor(seconds/60);
        let hours = Math.floor(minutes/60);
        let days = Math.floor(hours/24);
        
          hours = hours-(days*24);
          minutes = minutes-(days*24*60)-(hours*60);
          seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
          let res="";
          if(days>30){
            res=date;
          }else if(days){
            res=days+"d ago";
          }else if(hours){

            res=hours+"h ";
            if(minutes){
              res +=minutes+"m ";
            }            
            res +="ago";
          }else if(minutes){
            res =minutes+"m ago";

          }else{
            res ="now";
          }
          return res;

      }
  


  ngOnInit() {  
    console.log("ngOnInit call");   
    this.getAllTopic();
     if(!this.options){
      this.formoptions={}
      }else{
        this.formoptions=this.options;
      }
    
      this.forumsFields={};
      this.forumsEditFields={};
      this.forumsList=[];
      let filter={};
      if(this.postId > 0){
        
        filter={id:this.postId};    
       this.getForumDetail(filter);  
      }else{
        filter={limit:10};
        if(this.userData && this.userData.id){
          filter['userId']=this.userData.id;  
        }
        if(this.formoptions.topicId > 0){
          filter['topicId']=this.formoptions.topicId;  
        }
  
        this.getForums(filter);
      }   // this.getSubjects();
      //this.getMyBookmark();
  
      this.forumsFields.subjectid=0;
     // this.forumsEditFields.subjectid=0;


    this.ckeConfig = {
      height: 200,
      language: "en",
      
   //   extraPlugins: 'mathjax',
      
      mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
     // allowedContent: true,
     // extraPlugins: "divarea",
      toolbar: [
         // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
         // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
        //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
         // { name: "document", items: ["Source"] },
          { name: "insert", items: ["Image","customImageupload", "Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
         //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
        // For New Line  "/",
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
         // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
      ],
      filebrowserUploadUrl : this.global.objectStorage+'ckeditor/upload'
  };


    //this.forumsList=[{id:1,postTitle:"test Title",postContent:"<p>Test Content</p>",date:"2018-07-24 14:17:35",subjectid:1}];
    this.ngload=true;

  }

  ngOnChanges(){
    console.log('ngOnChanges');
    console.log(this.formoptions);
    console.log(this.options);
    console.log(this.ngload);
    if(this.ngload==true && this.options.topicId !=this.formoptions.topicId){
      console.log('call new one');
      this.formoptions=this.options;
      let filter={};
      filter={limit:10,offset:0};
      if(this.userData && this.userData.id){
        filter['userId']=this.userData.id;  
      }
      if(this.formoptions.topicId > 0){
        filter['topicId']=this.formoptions.topicId;  
      }
      console.log(filter);
      this.isnewList=true;
      this.getForums(filter);

    }
    
/*console.log('checl call');
    if(!this.options){
      this.formoptions={}
      }else{
        this.formoptions=this.options;
      }
      //console.log(this.formoptions);
      //this.subjects=[{id:0,title:"Select Subject"}];
      this.forumsFields={};
      this.forumsEditFields={};
      this.forumsList=[];
      let filter={};
      if(this.postId > 0){
        filter={id:this.postId};  
  
        this.getForumDetail(filter);
  
      }else{
        filter={limit:10};
        if(this.userData && this.userData.id){
          filter['userId']=this.userData.id;  
        }
        if(this.formoptions.topicId > 0){
          filter['topicId']=this.formoptions.topicId;  
        }
  
        this.getForums(filter);
      }   // this.getSubjects();
      //this.getMyBookmark();
  
      this.forumsFields.subjectid=0;
      this.forumsEditFields.subjectid=0;
    console.log('ngOnChanges');
    console.log(this.options);*/
  }


  customdecode(data){   
   return encodeURI(btoa(data));
  }


  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });

    this.uploaders.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
   this.imageuploaders.onAfterAddingFile = (item => {
    item.withCredentials = false;
 });
    /*

      this.uploader.onCompleteAll=function (){
        console.log(this.uploader);
        console.log("Complete Upload");
      }*/
      if(this.postId > 0){
        this.setPageCount();
      }
      //this.el.nativeElement.querySelector('.more-content').addEventListener('click', this.showfullContent.bind(this));
      
   }

   suggestionTopic(){
   // console.log('keyup');
    //console.log(this.forumsFields.postTitle);
      if(this.forumsFields.postTitle){        
        let obj={};
        obj['searchkey']=this.forumsFields.postTitle;
        this.forumsService.searchForums(obj).subscribe((data:any)=>{
          if(data.error==0){
            this.topicsuggestionList=data.result;
          }
        },(error:HttpErrorResponse)=>{
          this.msg="internal server error!";
        })
    }else{
      this.topicsuggestionList=[];

    }
   }

     strip_html_tags(str)
   {
      if ((str===null) || (str===''))
          return false;
     else
      str = str.toString();
     return str.replace(/<[^>]*>/g, '');
   }

   customContent(ans){
    //console.log('ans');
   // console.log(ans);
    let string="";
    ans.shortAns="";
    ans.shortImage="";
   let html =ans.answer;
   let htmlimage =ans.answer;
   //console.log(this.postId);

    if(this.postId  > 0 ||  ans.isfullcontent==true){
     string=html;
    }else{
     let chacterlength=0;
     let obj= html.split('<p>');
     var incre=0;
      /* for(var i in obj){
         incre++;  
         if(obj[i]){

           var StrippedString = obj[i].replace(/(<([^>]+)>)/ig,"");
           chacterlength +=StrippedString.length;
          // console.log(StrippedString);
           //string +='<p>'+obj[i];
           string +=StrippedString;
           //break;
         }
         if(chacterlength > 350){
           break;
         }                
       } */
       if(html){
       string= this.strip_html_tags(html).trim()+"...";
       ans.shortAns=string.substring(0,400);
       }
      

       //if(string.length > 350)
//console.log(incre +'----'+obj.length);
       if(string.length > 400){
        // console.log(html);
         if(htmlimage.indexOf('<img') !==false){
         var m,
         urls = [], 
         str = html,
         rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;
         while ( m = rex.exec( str ) ) {
             urls.push( m[1] );
         }

        // console.log( urls );
           if(urls.length > 0){
             ans.shortImage=urls[0];
             //string ='<div class="row grid-divider"><div class="col-sm-8 short-content-ans">'+string+'</div>'+'<div class="col-sm-4 short-image-ans"><img class="img-thumbnail" src="'+urls[0]+'" /></div></div>'; 
           }
         }
       //  let imageobj= html.split('<img');
         //console.log(imageobj);
       }else{
         ans.shortAns=string;
         ans.isfullcontent=true;
       }

    }
    //string=string+'<a class="more-content">more</a>';

   //return string;
  }
   showfullContent(ans){
     //console.log('click');
     ans.isfullcontent=true;
     if(Object.keys(this.userData).length > 0){ 
      this.forumsService.setAnswerView({userId:this.userData.id,answerId:ans.id}).subscribe((data:any)=>{


      },(error:HttpErrorResponse)=>{

        
      })
     } 
    

   }


   userBlock(userObj){
    let obj={}
    obj['userId']=userObj.id;
    this.forumsService.userBlock(obj).subscribe((data:any)=>{
      if(data.error==0){
        userObj.isBlocked=data.result;
      }     
    },(error:HttpErrorResponse)=>{
          this.msg="internal server error!";
        })
   }

   filterForum(){
    let obj={};
    obj['isnewList']=false;
    obj['limit']=10;
    obj['offset']=0;
    this.isRemaningForum=false;
    this.getForums(obj);
   }

   searchUser(){
    let obj={};
    obj['search']=this.userSearchkey;
    this.forumsService.searchUserList(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.userList=data.result;
      }
     
    },(error:HttpErrorResponse)=>{
         // this.msg="internal server error!";
        })

   }

   selectuser(userinfo,event){
    if(event.target.checked) {
      this.selectUser.push(userinfo.id);
    } else {
  
      var index =  this.selectUser.indexOf(userinfo.id);
      this.selectUser.splice(index,1);   
    } 

   }

   isuserChecked(id){
    let index = this.selectUser.indexOf(id);
   return (index < 0)?false:true;


   }
  
/*============================================= For Image Upload Code ===============================*/
  /********** For upload Attachement *****/
  onFileChanged(event) {
   this.uploader.uploadAll();
   this.progress=1;
  }

  uploadComment(commnetobj,content,isansedit){
    isansedit = typeof isansedit !== 'undefined' ? isansedit : null;
    
    if(isansedit !==null){
      this.editAnsattachment=isansedit;
    }else{
      this.editAnsattachment=false;
    }

    if(JSON.stringify(this.currentUploadComment) !== JSON.stringify(commnetobj)){
      this.currentCommentMediaIds=[];
    }
    this.currentUploadComment = commnetobj;    
    this.open(content);

  }

  onFileChangedComment(event) {
    this.uploaders.uploadAll();
     this.progress=1;
    //uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});
   // this[name].uploadAll();
   }

  

  


  downloadAttachment(attachmentObj){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    console.log(attachmentObj);

    var url=this.global.postAttachmentUrl+attachmentObj.uploadname;
    console.log(url);


    this.commonService.downloadFileByUrl(url).subscribe((data : any)=>{
    console.log(data);

    let durl = window.URL.createObjectURL(data);
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = durl;
    a.download = attachmentObj.title;
    a.click();
    window.URL.revokeObjectURL(durl);
    a.remove(); 
    },
     (error : HttpErrorResponse)=>{ 
       console.log(error);         
       this.msg="internal server error!";
     });

   

  }


  private isValidFileExtension(files){
    // Make array of file extensions
     var extensions = (this.fileExt.split(','))
                   .map(function (x) { return x.toLocaleUpperCase().trim() });
                   console.log(extensions+'test');
  //  // Get file extension
        var ext = files[0].name.toUpperCase().split('.').pop() || files[0].name;
        console.log(ext+'test321');
        // Check the extension exists
        var exists = extensions.includes(ext);
        if(!exists){
            this.fileExtExists=true;
        }
        else{
          this.fileExtExists=false;
        }
      
    
  }


  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  console.log("Success");
    console.log(item); 
    let data = JSON.parse(response); //success server response

      if(data.error==0){
        this.progress=0;
        console.log("set Ids");
        console.log(data.result.id);

        this.attachment.push(data.result.id);
        this.attachmentdetail.push(data.result);
        console.log(this.attachment);
      }else{

        this.msgpopup="There is some technical problem. Please try again";
        this.uploader.clearQueue();
      }
     
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let error = JSON.parse(response); //error server response
      this.msgpopup="There is some technical problem. Please try again";
      this.uploader.clearQueue();
  }

  onSuccessItemComment(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    console.log("Success");
      console.log(item); 
      let data = JSON.parse(response); //success server response
  
        if(data.error==0){
          this.progress=0;
          console.log("set Ids");
          console.log(data.result.id);  
          this.currentCommentMediaIds.push(data.result.mediaDetail);       
        }else{

          this.msgpopup="There is some technical problem. Please try again";
          this.uploaders.clearQueue();
        }
       
    }
  
    onErrorItemComment(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        let error = JSON.parse(response); //error server response
        this.msgpopup="There is some technical problem. Please try again";
        this.uploaders.clearQueue();
    }

   


    cancelCommentUpload(){
      this.currentCommentMediaIds=[];
      this.currentUploadComment={};
      let localmodalReference=this.modalReference;
      localmodalReference.close();
      this.uploaders.queue=[];

    }


    SaveCommentUpload(){      
      this.currentUploadComment.commentMedia=this.currentCommentMediaIds;
     // this.currentUploadComment={};    
      let localmodalReference=this.modalReference;
      localmodalReference.close();
      this.uploaders.queue=[];

      console.log(this.editAnsattachment);
      console.log(this.currentUploadComment)

      if(this.editAnsattachment!==false){
      
        if(!this.currentUploadComment['postAnswers'][this.editAnsattachment]['tmpAttachment'])
        this.currentUploadComment['postAnswers'][this.editAnsattachment]['tmpAttachment']=[];

        this.currentUploadComment['postAnswers'][this.editAnsattachment]['tmpAttachment']=this.currentCommentMediaIds;
        /*if(this.currentCommentMediaIds){
          for (const key in this.currentCommentMediaIds) {
            if (this.currentCommentMediaIds.hasOwnProperty(key)) {

              this.currentUploadComment['postAnswers'][this.editAnsattachment]['tmpAttachment'].push(this.currentCommentMediaIds[key]);
            }
          }
        }  */      
      }
      
    }

    removeAnsAttachment(obj,index,postAnswerContent){
      obj[index].postAnswer=false;
      if(confirm("Do you want to delete ?")){
         if(postAnswerContent.trim()=="" && obj.length==1){
          obj[index].postAnswer=true;
         }
  
     this.forumsService.removeAnsAttachment(obj[index]).subscribe((data:any)=>{
      if(data.error==0){
        try{
          obj.splice(index, 1);
        }catch(e){
          console.log(e);
        }            
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
      }
    }

   


    removetmpAnsAttachment(obj,index,postAnswerContent){
     
      if(confirm("Do you want to delete ?")){
             
         obj.splice(index, 1);
       
     
      }
    }

    

     /************** Voice Upload *************/

     getPostAttachmentPath(file){
      let filename=file;
        return this.global.postAttachmentUrl+filename;
       }
       voiceBox(commnetobj,content){
       this.currentUploadComment = commnetobj; 
        this.isVoiceActive=0;   
        this.open(content);
    
      }
    
  
       Start(){
        this.isVoiceActive=1;
        this.audiosContainer = document.getElementById('audios-container');
       
    this.captureUserMedia(this.mediaConstraints, this.onMediaSuccess, this.onMediaError) 
        
      }
    
      captureUserMedia(mediaConstraints, successCallback, errorCallback) {
    
    
    
        navigator.mediaDevices.getUserMedia(mediaConstraints).then((stream)=>{
    
          console.log(stream);
       
       
          this.audio = document.createElement('audio');
          this.audio = mergeProps(this.audio, {
               controls: false,
               muted: true
           });
       
           this.audio.srcObject = stream;
           //this.audio.play();
           this.audiosContainer.innerHTML = '';
           this.audiosContainer.appendChild(this.audio);
            //this.audiosContainer.appendChild(document.createElement('hr'));
          //console.log(new MediaStreamRecorder(stream));
         // var mediaRecorder={test:'test'}
          this.mediaRecorder = new MediaStreamRecorder(stream);
          this.mediaRecorder.stream = stream;
           var recorderType = 'WebAudio API (WAV)';
          
           if (recorderType === 'WebAudio API (WAV)') {
            this.mediaRecorder.recorderType = StereoAudioRecorder;
            this.mediaRecorder.mimeType = 'audio/wav';
           }
       
           console.log(this.mediaRecorder);
           
           
           // don't force any mimeType; use above "recorderType" instead.
           // mediaRecorder.mimeType = 'audio/webm'; // audio/ogg or audio/wav or audio/webm
           this.mediaRecorder.audioChannels = 2;
           this.mediaRecorder.ondataavailable = ((blob)=> {
           ;
       
            var fd = new FormData();
          //  fd.append("username", "Groucho");
            fd.append('upload', blob, 'myaudio.wav');          
           
            this.mediaRecorder.fileData=fd;
            this.mediaRecorder.blob=blob;
            /*
    */
            
    
            //var a = document.createElement('a');
              // a.target = '_blank';
              // a.innerHTML = 'Open Recorded Audio No. ' + (index++) + ' (Size: ' + bytesToSize(blob.size) + ') Time Length: ' + getTimeLength(timeInterval);
              // a.href = URL.createObjectURL(blob);
             //  audiosContainer.appendChild(a);
               //audiosContainer.appendChild(document.createElement('hr'));
           });
    
         /*  this.mediaRecorder.save = function(file, fileName) {
           console.log(file);
           console.log(fileName);
          };*/
            var timeInterval = 5000000;
           if (timeInterval) timeInterval = timeInterval;
           else timeInterval = 5 * 1000;
           // get blob after specific time interval
           this.mediaRecorder.start(timeInterval);
          
        
        }).catch(errorCallback);
      }
    
      onMediaSuccess(stream) {
        
    }
    onMediaError(e) {
        console.error('media error', e);
    }
    
    Stop(){
      this.isVoiceActive=2;
      this.mediaRecorder.stop();
      this.mediaRecorder.stream.stop();
      this.audio.pause();
      let blob= this.mediaRecorder.blob;
     let blobUrl =window.URL.createObjectURL(blob);
      this.audio = document.createElement('audio');
      this.audio = mergeProps(this.audio, {
           controls: true,
           muted: false
       });
   
       this.audio.src = blobUrl;
       this.audio.play();
       this.audiosContainer.innerHTML = '';
       this.audiosContainer.appendChild(this.audio);
  
      //localStorage.myfile = blob;
     /*/ console.log(localStorage);
     / var fd = new FormData();
      //  fd.append("username", "Groucho");
        fd.append('upload', blob, 'myaudio.wav');
     let val= fetch('http://localhost/madeeasy/upload.php',
            {
              method: 'post',
              body: fd
            })
          .then(function(response) {
           console.log(typeof response);
           console.log(response);
          })
          .catch(function(err){ 
            console.log(err);
          });
          console.log('resrsrsrrs');
      console.log(val);*/
  
  
      //let fileData=this.mediaRecorder.fileData;
      
  /*let fileObj=[];
      fileObj.push(fileData.getAll('upload'));*/
      //console.log(fd);
      //console.log(fd.getAll('upload'));
      /*this.makeFileRequest(this.global.siteUrl + 'voice/upload', [],fd).then((result) => {
             
          console.log('file res');
        console.log(result);
          }, (error) => {
              console.error(error);
          });*/
      
    
    }
    SaveVoice(){
     let blob = this.mediaRecorder.blob;
      var fd = new FormData();    
      fd.append('upload', blob, 'myaudio.wav');
      this.forumsService.saveVoice(fd).subscribe((data)=>{
        console.log(data);
        if(data['error']==0){
          if(!this.currentUploadComment.commentMedia){
            this.currentUploadComment.commentMedia=[];
          }
        this.currentUploadComment.commentMedia.push(data['result']['mediaDetail']);
        this.currentCommentMediaIds.push(data['result']['mediaDetail']);
        this.mediaRecorder = {};
        this.modalReference.close();
        }
  
      },(error:HttpErrorResponse)=>{
  
        console.log(error);
      })
    
    
    }
  
  
    makeFileRequest(url: string, params: Array<string>, formData) {
      return new Promise((resolve, reject) => {
        
        url='http://localhost/madeeasy/upload.php';
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.responseType = 'json';
          /*var formData: any = new FormData();
       
          for(var i = 0; i < files.length; i++) {
              formData.append("upload", files[i], files[i].name);
          }*/
          xhr.onreadystatechange = function () {
              if (xhr.readyState == 4) {
                console.log(xhr.response);
              
           //   if(xhr.response){
                  if (xhr.status == 200) {
                  //    var res=xhr.response.replace('###','');
                      resolve(JSON.parse(xhr.response));
                  } else {
                    resolve(JSON.parse(xhr.response));
                  //  var res=xhr.response.replace('###','');
                      //reject(xhr.response);
                  }
                
              }
          }
          xhr.open("POST", url, true);
          xhr.send(formData);
      });
  }
  cancelVoice(){
    this.mediaRecorder = {};
    this.modalReference.close();
  }
 
  checkFileextension(fileName){
    return this.commonService.checkFileextension(fileName);
   }

  othertag(){

    if(this.othertagBox){
        this.othertagBox=false;
        //this.OthertopicInput='';
    }else{
      this.othertagBox=true;
    }
 }

  /*********code for time********/
  
datetimeMerge(date,time){
  let string="";
  let month = (date.month<10)?'0'+date.month:date.month ;
  let day = (date.day<10)?'0'+date.day:date.day ;
  
  let hour=(time.hour<10)?'0'+time.hour:time.hour ;
  let minute=(time.minute<10)?'0'+time.minute:time.minute ;

  string=date.year+'-'+month+'-'+day+' '+hour+':'+minute+':00';
  
  return string;

}
time = {hour: 13, minute: 30};
meridian = true;

toggleMeridian() {

  this.meridian = !this.meridian;
}

// This is for the seconds
seconds = true;

toggleSeconds() {
this.seconds = !this.seconds;
}

// This is for the spinners
spinners = true;

toggleSpinners() {
  this.spinners = !this.spinners;
}

// This is for the column step
time2: NgbTimeStruct = {hour: 13, minute: 30, second: 0};
currentDate=new Date();
minDate : NgbDateStruct = {year: this.currentDate.getFullYear(), month: this.currentDate.getMonth()+1, day: this.currentDate.getDate()};
hourStep = 1;
minuteStep = 15;
secondStep = 30;



// This is for the validation
time3;
ctrl = new FormControl('', (control: FormControl) => {
const value = control.value;

if (!value) {
  return null;
}

if (value.hour < 12) {
  return {tooEarly: true};
}
if (value.hour > 13) {
  return {tooLate: true};
}

return null;
});

/*********code for time********/
  

//ckeditor Image upload

customImageupload(event,content){
  

 // CKEDITOR.instances['editor1'].setData("11111111111111111111111");
  //return false;
  console.log(event.name);
  this.ckeditorevent=event;
    this.open(content);

}
onFileChangedImage(event){
  this.imageuploaders.uploadAll();
  this.progress = 1;
 }

 onSuccessItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  console.log("Success");
    console.log(item); 
    let data = JSON.parse(response); //success server response

      if(data.error==0){
        this.progress = 0;
        console.log(this.ckeditorevent.name);
        let fileurl=this.global.objectStorage+'ckeditor/'+data.result.mediaDetail.uploadname;       
        let imagetag="<img src='"+fileurl+"' alt='"+data.result.mediaDetail.title+"'>";
        console.log(imagetag);       
        CKEDITOR.instances[this.ckeditorevent.name].insertHtml(imagetag);
        this.imageuploaders.clearQueue();
        this.modalReference.close();
      }else{

        this.msgpopup="There is some technical problem. Please try again";
        this.imageuploaders.clearQueue();
      }
     
  }

  onErrorItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let error = JSON.parse(response); //error server response
      this.msgpopup="There is some technical problem. Please try again";
      this.imageuploaders.clearQueue();
  }

  delQuestionAttached(forumsList,postObj,index){
    console.log(postObj);
   var r=confirm("Do you want to delete ?");
   if(r==true){
     let obj={};
     obj['id']=postObj.id;
     
 this.forumsService.removePostattched(obj).subscribe((data:any)=>{
   forumsList.splice(index,1);
 },(error:HttpErrorResponse)=>{
   this.msg="internal server error!";

 })
    

   }
  }

 
  openAttachedImage(content,img,postTitle) {
    this.AttachedImagePopup=this.AttachmentUrl+img;
    this.postTitle=postTitle;
   this.modalReference = this.modalService.open(content, {
     backdrop: "static",
     keyboard: false,
     size: "lg",
   });
 }

 questionProfile(postObj,type){
  var obj={};
  obj['postId']=postObj.id;
  obj['userId']=this.userData.id;
  obj['type']=type;
  this.forumsService.isQuestionProfile(obj).subscribe((data:any)=>{
    if(data.error==0){
      if(type=='Yes'){
        postObj.isQuestionProfile="Yes";
      }else{
        postObj.isQuestionProfile="No";
      }
      postObj.showOption=false;
  
    }
  
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";
  })
  
  }

  viewuser(questionPost,content){
    this.open(content);
    this.forumsService.getUserProfile({userId:questionPost.userId}).subscribe((data:any)=>{
      if(data.error==0){
            this.userProfileData= data.result;
      }
    
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })

  }
}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/admin-forum/admin-forum.component.ts